export const REQUEST = 'AUTH_REFRESH_TOKEN_REQUEST';
export const SUCCESS = 'AUTH_REFRESH_TOKEN_SUCCESS';
export const FAILURE = 'AUTH_REFRESH_TOKEN_FAILURE';

export const fetchRequest = () => ({
  type: REQUEST
});

export const fetchSuccess = (data) => ({
  type: SUCCESS,
  payload: data
});

export const fetchFailure = (error) => ({
  type: FAILURE,
  payload: error
});
